import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
  required,
} from "react-admin";
import { useClub } from "../../club/ClubContext";

export function ShopItemCreate() {
  const { clubId } = useClub();

  return (
    <Create title="Artikel erstellen">
      <SimpleForm defaultValues={{ club_id: clubId, active: true, has_imprint: false }}>
        <TextInput source="name" label="Name" validate={required()} fullWidth />
        <TextInput
          source="description"
          label="Beschreibung (optional)"
          fullWidth
          multiline
          rows={2}
        />
        <NumberInput
          source="price"
          label="Preis (€)"
          validate={required()}
          min={0}
          step={0.01}
          fullWidth
        />
        <TextInput
          source="sizes_text"
          label="Größen (kommagetrennt, z.B.: XS, S, M, L, XL)"
          fullWidth
          helperText="Leer lassen wenn keine Größenauswahl nötig"
        />
        <BooleanInput source="has_imprint" label="Aufdruck" />
        <BooleanInput source="active" label="Aktiv (im Shop sichtbar)" />
        <ImageInput source="images_new" label="Bilder" accept={{ "image/*": [] }} multiple>
          <ImageField source="src" title="title" />
        </ImageInput>
        <TextInput source="club_id" sx={{ display: "none" }} />
      </SimpleForm>
    </Create>
  );
}
